import React from 'react';
import styled from 'styled-components';

const PerksWrapper = styled.section`
  width: 100%;
  background: linear-gradient(135deg, #020611 0%, #050B15 50%, #020611 100%);
  padding: 4rem 0;
  display: flex;
  justify-content: center;
  position: relative;
`;

const GradientOrb = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, transparent 70%);
  pointer-events: none;
`;

const PerksContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  padding: 0 2rem;
  position: relative;
  z-index: 2;
`;

const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const Title = styled.h2`
  font-family: 'Very Sans Headline', 'Very Sans', sans-serif;
  font-size: 3rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 1rem 0;
  
  span {
    background: linear-gradient(135deg, #3B82F6 0%, #a78bfa 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const Subtitle = styled.p`
  font-family: 'Very Sans Medium', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  color: #94A3B8;
  margin: 0 auto;
  max-width: 600px;
  line-height: 1.6;
`;

const PerksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
`;

const PerkCard = styled.div`
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: ${props => props.brandColor || '#3B82F6'};
    opacity: 0.8;
  }
  
  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(59, 130, 246, 0.3);
    box-shadow: 0 12px 30px rgba(59, 130, 246, 0.15);
  }
`;

const PerkHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const PerkIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  background: ${props => props.brandColor || '#3B82F6'};
  flex-shrink: 0;
`;

const PerkInfo = styled.div`
  flex: 1;
`;

const PerkName = styled.h3`
  font-family: 'Very Sans Bold', sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.25rem 0;
`;

const PerkCategory = styled.span`
  font-family: 'Very Sans Medium', sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
  color: #94A3B8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const PerkReward = styled.div`
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 8px;
  padding: 0.75rem;
  text-align: center;
  margin-bottom: 1rem;
`;

const RewardAmount = styled.div`
  font-family: 'Very Sans Bold', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.25rem;
`;

const RewardText = styled.div`
  font-family: 'Very Sans Medium', sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
  color: #94A3B8;
`;

const PerkDescription = styled.p`
  font-family: 'Very Sans Light', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  color: #94A3B8;
  line-height: 1.5;
  margin: 0;
`;

const CTASection = styled.div`
  text-align: center;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 16px;
  padding: 2rem;
`;

const CTATitle = styled.h3`
  font-family: 'Very Sans Bold', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 0.75rem 0;
`;

const CTAText = styled.p`
  font-family: 'Very Sans Medium', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  color: #94A3B8;
  margin: 0 0 1.5rem 0;
  line-height: 1.5;
`;

const CTAButton = styled.button`
  background: #3B82F6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.875rem 2rem;
  font-family: 'Very Sans', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    background: #2563EB;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(59, 130, 246, 0.4);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const Perks = () => {
  const perksData = [
    {
      name: 'Netflix',
      category: 'Entertainment',
      icon: 'N',
      brandColor: '#e50914',
      reward: 'Up to $10',
      description: 'Get cashback on your monthly Netflix subscription and binge-watch your favorite shows guilt-free.'
    },
    {
      name: 'Spotify',
      category: 'Music',
      icon: 'S',
      brandColor: '#1db954',
      reward: 'Up to $10',
      description: 'Earn rewards on your Spotify Premium subscription and enjoy unlimited music streaming.'
    },
    {
      name: 'Amazon Prime',
      category: 'Shopping',
      icon: 'A',
      brandColor: '#ff9900',
      reward: 'Up to $15',
      description: 'Get cashback on Amazon Prime membership and enjoy free shipping with rewards.'
    },
    {
      name: 'Apple Music',
      category: 'Music',
      icon: 'A',
      brandColor: '#000000',
      reward: 'Up to $10',
      description: 'Earn rewards on your Apple Music subscription and discover new artists with benefits.'
    },
    {
      name: 'Uber Eats',
      category: 'Food Delivery',
      icon: 'U',
      brandColor: '#00d4aa',
      reward: 'Up to $20',
      description: 'Get cashback on food delivery orders and enjoy meals from your favorite restaurants.'
    },
    {
      name: 'Disney+',
      category: 'Entertainment',
      icon: 'D+',
      brandColor: '#113ccf',
      reward: 'Up to $8',
      description: 'Earn rewards on Disney+ subscription and stream the latest movies and series.'
    }
  ];

  return (
    <PerksWrapper>
      <GradientOrb />
      <PerksContainer>
        <HeaderSection>
          <Title>Your Hydrixpay Card Comes With <span>Exclusive Perks</span></Title>
          <Subtitle>
            Earn cashback rewards at your favorite brands and services. 
            Simply use your nomafi card and watch the rewards add up automatically.
          </Subtitle>
        </HeaderSection>

        <PerksGrid>
          {perksData.map((perk, index) => (
            <PerkCard key={index} brandColor={perk.brandColor}>
              <PerkHeader>
                <PerkIcon brandColor={perk.brandColor}>
                  {perk.icon}
                </PerkIcon>
                <PerkInfo>
                  <PerkName>{perk.name}</PerkName>
                  <PerkCategory>{perk.category}</PerkCategory>
                </PerkInfo>
              </PerkHeader>

              <PerkReward>
                <RewardAmount>{perk.reward}</RewardAmount>
                <RewardText>Monthly Cashback</RewardText>
              </PerkReward>

              <PerkDescription>
                {perk.description}
              </PerkDescription>
            </PerkCard>
          ))}
        </PerksGrid>

        <CTASection>
          <CTATitle>Ready to start earning rewards?</CTATitle>
          <CTAText>
            Join thousands of users who are already earning cashback on their favorite subscriptions and services.
          </CTAText>
          <CTAButton>
            Get Your Hydrixpay Card
          </CTAButton>
        </CTASection>
      </PerksContainer>
    </PerksWrapper>
  );
};

export default Perks;